
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-eyeclosed",
  components: {},
})
export class IconEyeClosed extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconEyeClosed;
